/**
 * Given a carousel index (which includes interstitials like videos),
 * returns the corresponding image from the images array.
 * Returns undefined if the carousel index points to an interstitial.
 */
export function getImageAtCarouselIndex(
  carouselIndex: number,
  images: Array<App.Image>,
  interstitials: Array<{ position: number | 'start' | 'end' }>,
): App.Image | undefined {
  if (interstitials.length === 0) return images[carouselIndex]

  let interstitialsBefore = 0
  for (const interstitial of interstitials) {
    const pos = interstitial.position === 'start' ? 0
      : interstitial.position === 'end' ? images.length
        : interstitial.position - 1
    if (pos === carouselIndex) return undefined
    if (pos < carouselIndex) interstitialsBefore++
  }
  return images[carouselIndex - interstitialsBefore]
}
